import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./admin.css";
import { AuthProvider, useAuth } from "./AuthContext";
import { Spinner } from "./Primitives";
import Layout from "./Layout";
import Login from "./Login";
import Dashboard from "./pages/Dashboard";
import Games from "./pages/Games";
import Platforms from "./pages/Platforms";
import Providers from "./pages/Providers";
import Signals from "./pages/Signals";
import EventsHistory from "./pages/EventsHistory";
import SettingsPage from "./pages/Settings";
import Traffic from "./pages/Traffic";
import Visitors from "./pages/Visitors";
import Links from "./pages/Links";
import Users from "./pages/Users";
import Invite from "./Invite";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="mia-admin min-h-screen flex items-center justify-center">
        <Spinner size={28} />
      </div>
    );
  }
  if (user === null) return <Navigate to="/admin/login" replace />;
  return children;
}

function OwnerOnly({ children }) {
  const { user } = useAuth();
  return user?.permissions?.manage_users ? children : <Navigate to="/admin" replace />;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/admin" replace />;
  return children;
}

export default function AdminApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<PublicOnly><Login /></PublicOnly>} />
        <Route path="convite" element={<Invite />} />
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="games" element={<Games />} />
          <Route path="platforms" element={<Platforms />} />
          <Route path="providers" element={<Providers />} />
          <Route path="signals" element={<Signals />} />
          <Route path="events" element={<EventsHistory />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="traffic" element={<Traffic />} />
          <Route path="visitors" element={<Visitors />} />
          <Route path="links" element={<Links />} />
          <Route path="users" element={<OwnerOnly><Users /></OwnerOnly>} />
        </Route>
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AuthProvider>
  );
}
